import { MembershipProfileCurrency } from '@models/membership/MembershipProfileCurrency'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_MEMBERSHIP_PROFILES_URL, MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL } from '@utils/urls'
import { AxiosError } from 'axios'

const fetchMembershipProfileCurrencies = (params: TableParams) =>
  SBAPI.FetchPaginated<MembershipProfileCurrency[]>(
    MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL,
    params
  )

const createMembershipProfileCurrency = (currency: MembershipProfileCurrency) =>
  SBAPI.Post(`${MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL}`, currency).catch(
    (error: AxiosError) => {
      throw new Error(error.message)
    }
  )

const batchUpdateMembershipProfileCurrencies = (
  profileId: number,
  items: { id: number; amount: number }[]
) =>
  SBAPI.Put(
    `${MEMBERSHIP_MEMBERSHIP_PROFILES_URL}/${profileId}/currencies/batch-update`,
    { items }
  )

const deleteMembershipProfileCurrency = (currency: MembershipProfileCurrency) =>
  SBAPI.Delete(`${MEMBERSHIP_MEMBERSHIP_PROFILE_CURRENCIES_URL}/${currency.id}`)

export {
  batchUpdateMembershipProfileCurrencies,
  createMembershipProfileCurrency,
  deleteMembershipProfileCurrency,
  fetchMembershipProfileCurrencies,
}
